import ArtifactGroupType from "@/roc/museum/base/ArtifactGroupType";

const CorsairsSkull = {
  id: '96',
  name: 'Corsairs Skull',
  icon: 'CorsairsSkull',
  groupIcon: 'LegendsOfTheHighSeas',
  type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
  power: 50
};

export default CorsairsSkull;
